
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"115","height":"117","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#EDEDF4","width":"115","height":"117","rx":"4"}}),_c('rect',{attrs:{"fill":"#CECED0","width":"115","height":"13","rx":"4"}}),_c('path',{attrs:{"fill":"#FFF","d":"M8.425 51.84h98.15v17.164H8.425zM37.07 26.961h33.278v5.024H37.07zm0 7.895h24.853v5.024H37.07z"}}),_c('text',{attrs:{"font-family":"Poppins-Bold, Poppins","font-size":"16.8","font-weight":"bold","fill":"#4FDCA7"}},[_c('tspan',{attrs:{"x":"12.565","y":"69.813"}},[_v('******')])]),_c('ellipse',{attrs:{"fill":"#FFF","cx":"18.535","cy":"33.42","rx":"10.11","ry":"10.047"}}),_c('ellipse',{attrs:{"fill":"#FFF","cx":"92.425","cy":"6.42","rx":"3","ry":"2.981"}}),_c('ellipse',{attrs:{"fill":"#FFF","cx":"100.425","cy":"6.42","rx":"3","ry":"2.981"}}),_c('ellipse',{attrs:{"fill":"#FFF","cx":"108.425","cy":"6.42","rx":"3","ry":"2.981"}}),_c('path',{attrs:{"fill":"#4FDCA7","fill-rule":"nonzero","d":"M97.883 63.67l-3.61-3.248 2.825.929 5.179-4.176z"}})])])
          )
        }
      }
    